import { AlertTriangle } from 'lucide-react';
import { Button } from '@/shared/components/ui/button';
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/shared/components/ui/dialog';

export type StockShortage = {
  articulo: string;
  requerido: number;
  disponible: number;
};

/**
 * Shown when the Aceptar flow's live inventory revalidation finds that at
 * least one line exceeds current stock. Mirrors PowerApps `PopUp_SinStock`
 * ([Screen_DetalleVenta.pa.yaml](msapp_extracted/Src/Screen_DetalleVenta.pa.yaml) lines ~1547-1573):
 * the user cannot proceed with acceptance and has to adjust the cotización
 * before coming back.
 */
export function SinStockDialog({
  open,
  shortages,
  onClose,
}: {
  open: boolean;
  shortages: StockShortage[];
  onClose: () => void;
}) {
  return (
    <Dialog open={open} onOpenChange={(next) => !next && onClose()}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <div className="flex items-start gap-3">
            <span className="mt-0.5 inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-rose-100 text-rose-600">
              <AlertTriangle className="h-5 w-5" aria-hidden />
            </span>
            <div className="flex flex-col gap-1">
              <DialogTitle>Stock insuficiente</DialogTitle>
              <DialogDescription>
                No hay stock disponible para aceptar la cotización. Ajustá
                las cantidades o esperá a que ingrese más stock.
              </DialogDescription>
            </div>
          </div>
        </DialogHeader>
        <DialogBody>
          <ul className="divide-y divide-border rounded-lg border">
            {shortages.map((s, i) => (
              <li
                key={`${s.articulo}-${i}`}
                className="flex items-center justify-between gap-3 px-3 py-2 text-sm"
              >
                <span className="font-medium text-foreground">{s.articulo}</span>
                <span className="whitespace-nowrap text-xs text-muted-foreground">
                  Requerido:{' '}
                  <span className="font-semibold text-rose-700">{s.requerido}</span>
                  {' · '}
                  Disponible:{' '}
                  <span className="font-semibold text-foreground">{s.disponible}</span>
                </span>
              </li>
            ))}
          </ul>
        </DialogBody>
        <DialogFooter>
          <Button type="button" onClick={onClose} variant="outline">
            Entendido
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
